import * as React from "react";
import { useMachine } from "@xstate/react";
import { Button, Loader, Separator, Text } from "@nju/ui";
import { simSetDigitsMachine } from "./SimSetDigits.machine";

interface ISimSetDigitsProps {
  orderId: string | undefined;
}

export function SimSetDigits({ orderId }: ISimSetDigitsProps) {
  const [current, send] = useMachine(simSetDigitsMachine, {
    context: {
      orderId,
    },
  });

  const { context } = current;
  const { simDigits } = context;

  const handleFetchSimSetDigits = React.useCallback(() => {
    return send({ type: "FETCH_SIM_DIGITS" });
  }, [send]);

  return (
    <>
      <Separator size="xs" tone="invisible" />
      <Text testId="dev-tip-sim-number">
        DevTip SIM digits: {current.matches("loading") && <Loader />}
        {simDigits && !current.matches("loading") && simDigits}
      </Text>
      <Button
        onPress={() => {
          return handleFetchSimSetDigits();
        }}
        size="inline"
        testId="dev-tip-sim-number-button"
        variant="simple"
        withUnderline={true}
      >
        Numer SIM
      </Button>
    </>
  );
}
